import {useApi} from '@/haligator-factory';
import {useHalState} from '@synako/haligator';
import {useEffect} from 'react';
import {hotjar} from 'react-hotjar';

export default function Hotjar() {
  const {data} = useHalState(useApi().follow('get-hotjar_configuration'));
  useEffect(() => {
    if (data?.site_id && typeof window !== 'undefined') {
      try {
        hotjar.initialize({
          id: parseInt(data.site_id),
          sv: 6,
        });
      } catch (error) {
        console.error('Error initializing Hotjar', error);
      }
    }
  }, [data?.site_id]);
  return null;
}
